export default "__VITE_ASSET__C80XdIp3__"